var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"mobile-only messages-header",attrs:{"to":{name: 'DashboardMessages'},"title":"Consulter votre messagerie COOLOC"}},[_c('div',[_c('span',{staticClass:"chat-icon"}),_vm._v(" "),(_vm.nb_unread > 0)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.nb_unread))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }